import { StyledChip } from './CellChip.styles';

export const CellChip = ({ value, type }) => {
  return <StyledChip label={value} type={type} />;
};
